// React & External Libraries
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Utilities & Helpers
import { handleDeleteEntity } from "../../../utils/deleteHelper";
import checkPermissions from "../../global-functions/checkPermissionsFunc";

// Redux Actions
import { getStatesFunc } from "../../../store/custom-actions/states-actions/GetStatesSlicer";
import { deleteStateFunc } from "../../../store/custom-actions/states-actions/DeleteStateSlicer";

// UI Components
import PageTitle from "../../layouts/PageTitle";
import SearchBox from "../../components/ui/SearchBox";
import Table from "../../components/ui/Table";
import Pagination from "../../components/ui/Pagination";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";

// Custom Forms
import NewStateForm from "../../custom-forms/states/NewStateForm";
import UpdateStateForm from "../../custom-forms/states/UpdateStateForm";
import { getSiteSetting } from "../../../utils/getSiteSetting";

export default function StatesPage() {
  const { t } = useTranslation();
  const { loading: getStatesLoading, data: statesData } = useSelector(
    (state) => state.getStatesSlicer
  );
  const { loading: deleteStatesLoading } = useSelector(
    (state) => state.deleteStateSlicer
  );
  const site_global_currency = getSiteSetting("site_global_currency");
  const [statesList, setStatesList] = useState([]);
  const [showNewStateForm, setShowNewStateForm] = useState();
  const [showUpdateForm, setShowUpdateForm] = useState();
  const [stateWichUpdate, setStateWhichUpdate] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const getCitites = async () => {
      try {
        dispatch(getStatesFunc());
      } catch (error) {
        console.log(error);
      }
    };
    getCitites();
  }, []);
  useEffect(() => {
    statesData && setStatesList(statesData);
    statesData &&
      (jobData.current = statesData.slice(
        activePag.current * sort,
        (activePag.current + 1) * sort
      ));
  }, [statesData]);
  const sort = 20;
  let paggination = Array(Math.ceil(statesList.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const activePag = useRef(0);
  const jobData = useRef(
    statesList.slice(activePag.current * sort, (activePag.current + 1) * sort)
  );
  const onClick = (i) => {
    activePag.current = i;
    jobData.current = statesList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
  };
  const search = () => {
    if (searchValue !== "") {
      const searchResult =
        statesData &&
        statesData.length >= 1 &&
        statesData.filter((state) =>
          state.name
            .toLocaleLowerCase()
            .includes(searchValue.toLocaleLowerCase())
        );
      jobData.current = searchResult;
    } else {
      dispatch(getStatesFunc());
    }
  };
  useEffect(() => {
    searchValue == "" && dispatch(getStatesFunc());
  }, [searchValue]);

  const handleDeleteState = (id, entityName = "") => {
    handleDeleteEntity({
      id,
      entityName: entityName,
      deleteFunc: deleteStateFunc,
      dispatch,
      refetchFunc: getStatesFunc,
      t,
    });
  };

  return (
    <>
      <PageTitle motherMenu={"Dashboard"} activeMenu={"States"} />
      {!getStatesLoading &&
        statesList.length < 1 &&
        checkPermissions(
          "create addresses",
          <div className="relative mt-2 flex justify-end items-center">
            <Link
              to={"#"}
              className="btn btn-primary btn-sm"
              onClick={() => [setShowNewStateForm(true)]}
            >
              {t("Create")}
            </Link>
          </div>
        )}
      {/* {

            (
                statesData
                ?
                ( */}

      <div className="col-12">
        <div className="card">
          <div className="card-header flex justify-between items-center">
            <SearchBox
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              onSearch={() => search()}
            />
            <Link
              to={"#"}
              className="btn btn-primary btn-md"
              onClick={() => [setShowNewStateForm(true)]}
            >
              {t("Create")}
            </Link>
          </div>
          <div className="card-body">
            <div className="w-100 table-responsive">
              <div id="example_wrapper" className="dataTables_wrapper">
                <Table
                  showIndex={true}
                  startIndex={activePag.current * sort}
                  columns={[
                    { header: t("Name"), render: (row) => row.name },
                    { header: t("Code"), render: (row) => row.code },
                    {
                      header: t("Status"),
                      render: (row) => (
                        <span
                          className={`relative text-sm rounded-lg text-white ${
                            row.active == 1 ? "bg-green-500" : "bg-red-500"
                          } p-1`}
                        >
                          {row.active == 1 ? t("Active") : t("Not Active")}
                        </span>
                      ),
                    },
                    {
                      header: t("Country"),
                      render: (row) => row?.country?.name || "-",
                    },
                    {
                      header: t("Cities"),
                      render: (row) => row?.cities_count || 0,
                    },
                    {
                      header: t("Shipping"),
                      render: (row) =>
                        row?.shipping_amount + " " + site_global_currency,
                    },
                  ]}
                  data={jobData.current}
                  loading={getStatesLoading}
                  actions={(state) => (
                    <>
                      {checkPermissions(
                        "update addresses",
                        <Link
                          to="#"
                          className="btn btn-primary shadow btn-xs sharp me-1"
                          onClick={() => {
                            setShowUpdateForm(true);
                            setStateWhichUpdate(state);
                          }}
                        >
                          <i className="fas fa-pencil-alt"></i>
                        </Link>
                      )}
                      {checkPermissions(
                        "delete addresses",
                        <Link
                          to="#"
                          className="btn btn-danger shadow btn-xs sharp"
                          onClick={() => {
                            handleDeleteState(state.id, state.name);
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </Link>
                      )}
                    </>
                  )}
                />
                <Pagination
                  totalItems={statesList.length}
                  currentPage={activePag.current}
                  perPage={sort}
                  onPageChange={(page) => onClick(page)}
                  t={t}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )
                :
                <FaildLoadData
                    refetchDataFunc={() => dispatch(getStatesFunc(states_API_URL))}
                />
            )
        } */}
      <LoadingScreen loading={deleteStatesLoading} />
      <NewStateForm
        show={showNewStateForm}
        onHide={() => setShowNewStateForm(false)}
      />
      <UpdateStateForm
        show={showUpdateForm}
        onHide={() => setShowUpdateForm(false)}
        stateId={stateWichUpdate.id}
        oldName={stateWichUpdate.name}
        oldCode={stateWichUpdate.code}
        oldStatus={stateWichUpdate.active}
        oldShipping={stateWichUpdate.shipping_amount}
        oldCountry={stateWichUpdate.country_id}
      />
    </>
  );
}
